import { GET_DOCTOR_DASHBOARD } from "./DoctorDashboardActions";

const initialState = {
  dashboardData: {},
};

const doctorDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DOCTOR_DASHBOARD:
      return {
        ...state,
        dashboardData: action.payload,
      };
    default:
      return state;
  }
};

export default doctorDashboardReducer;
